define("settings/templates/groups", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <MigrationBanner />
  
  {{outlet}}
  
  {{#if this.showInstagramSelector}}
    <Shared::Social::InstagramModal />
  {{/if}}
  */
  {
    "id": "sIeUG4GE",
    "block": "[[[8,[39,0],null,null,null],[1,\"\\n\\n\"],[46,[28,[37,2],null,null],null,null,null],[1,\"\\n\\n\"],[41,[30,0,[\"showInstagramSelector\"]],[[[1,\"  \"],[8,[39,4],null,null,null],[1,\"\\n\"]],[]],null]],[],false,[\"migration-banner\",\"component\",\"-outlet\",\"if\",\"shared/social/instagram-modal\"]]",
    "moduleName": "settings/templates/groups.hbs",
    "isStrictMode": false
  });
});